/**
 * A logo is a file this app serves from /branding. The client profile's logo
 * values become an `<img src>` and a `fetch` in the signed-in user's browser
 * (term sheet, report preview, workbook export, login), so anything that could
 * leave the origin — a scheme, "//host", "@host", a backslash, ".." — is not a
 * logo: it reads as no mark. Mirrors `is_branding_path` in
 * backend/app/core/client_profile.py, which the server applies on write and read.
 */
const BRANDING_PATH = /^\/branding\/[A-Za-z0-9._-]+(?:\/[A-Za-z0-9._-]+)*$/

/** `value` if it is a same-origin path to a file under /branding, else ''. */
export function safeBrandingPath(value: unknown): string {
  if (typeof value !== 'string' || !BRANDING_PATH.test(value)) return ''
  // "." and ".." are dots-only names the character class admits.
  return value.split('/').some((segment) => segment !== '' && /^\.+$/.test(segment)) ? '' : value
}
